import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

/* Silent handler for the redirect back from Emergent-managed Google sign-in.
   The URL fragment carries ?#session_id=... which we exchange for our session cookie. */
const AuthCallback = () => {
    const hasProcessed = useRef(false);
    const navigate = useNavigate();
    const { setUser } = useAuth();

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const sessionId = window.location.hash
            .split("session_id=")[1]
            ?.split("&")[0];
        if (!sessionId) {
            navigate("/login");
            return;
        }
        axios
            .post(
                `${process.env.REACT_APP_BACKEND_URL}/api/auth/google/session`,
                { session_id: sessionId },
                { withCredentials: true }
            )
            .then((res) => {
                setUser(res.data);
                navigate("/");
            })
            .catch(() => navigate("/login"));
    }, [navigate, setUser]);

    return null;
};

export default AuthCallback;
